import { render, staticRenderFns } from "./@PopupHistorySendMail.vue?vue&type=template&id=200a912b&scoped=true&"
import script from "./@PopupHistorySendMail.vue?vue&type=script&lang=js&"
export * from "./@PopupHistorySendMail.vue?vue&type=script&lang=js&"
import style0 from "./@PopupHistorySendMail.vue?vue&type=style&index=0&id=200a912b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a912b",
  null
  
)

export default component.exports